import Progress from 'redux-progress';

import { CART_FOR_ORDER, PO_NUMBER_UPDATE, SOURCE } from 'modules/mac/duck/actions/cart';
import type { MACCartAction, MACCartState } from '../models/cart';
import { PO_NUMBER_UPDATE_MODAL_CLOSE } from '../actions/orders';

export const initialState: MACCartState = {
  order: {},
  source: Progress.none,
  purchaseOrderNumberUpdated: {},
};

export default (state: MACCartState = initialState, action: MACCartAction): MACCartState => {
  switch (action.type) {
    case CART_FOR_ORDER:
      return {
        ...state,
        order: { ...state.order, [action.orderId]: action.progress },
      };
    case PO_NUMBER_UPDATE:
      return {
        ...state,
        purchaseOrderNumberUpdated: {
          ...state.purchaseOrderNumberUpdated,
          [action.poNumber]: action.progress,
        },
      };
    case SOURCE:
      return {
        ...state,
        source: action.progress,
      };
    case PO_NUMBER_UPDATE_MODAL_CLOSE:
      return {
        ...state,
        order: { ...state.order, [action.orderId]: undefined },
      };
    default:
      return state;
  }
};
